export const customerPageRouteName = "/master-data/customer";
export const addCustomerPageRouteName = "/master-data/customer/add";
export const editCustomerPageRouteName = (id?: string) =>
	`/master-data/customer/${id ?? ":id"}/edit`;
export const detailCustomerPageRouteName = (id?: string) =>
	`/master-data/customer/${id ?? ":id"}/detail`;
export const draftCustomerPageRouteName = "/master-data/customer/draft";

